import { Alert, Flex, List, Segmented, Table, Tag } from "antd";
import React, { useMemo, useState } from "react";
import { CustomTitle } from "../../../components";
import TimesTable from "../../../components/TimesTable";
import { WarningIcon } from "../../../assets/icons/icons";

// const hoursData = [
//   { day: "Monday", time: "3:00 AM - 10:30 PM" },
//   { day: "Tuesday", time: "3:00 AM - 10:30 PM" },
//   { day: "Wednesday", time: "3:00 AM - 10:30 PM" },
//   { day: "Thursday", time: "3:00 AM - 10:30 PM" },
//   { day: "Friday", time: "3:00 AM - 10:30 PM" },
//   { day: "Saturday", time: "3:00 AM - 10:30 PM" },
//   { day: "Sunday", time: "6:00 AM - 10:30 PM" },
// ];


const TabsContent = ({data , address}) => {

  // console.log('address in tab content : ' , address)
  // const [selectedTab, setSelectedTab] = useState("dropoff");

  const columns = [
    {
      title: "",
      dataIndex: "day",
      key: "day",
      render: (text) => <span style={{ fontWeight: 500 }}>{text}</span>,
    },
    {
      title: "",
      dataIndex: "hours",
      key: "hours",
      align: "right",
    },
  ];

  const getFullDayName = (abbreviation) => {
    const dayNames = {
      MON: "Monday",
      TUE: "Tuesday",
      WED: "Wednesday",
      THU: "Thursday",
      FRI: "Friday",
      SAT: "Saturday",
      SUN: "Sunday",
    };
    return dayNames[abbreviation] || abbreviation;
  };


  // Memoize the table data generation to prevent unnecessary recalculations
  const dataSource = useMemo(() => {
    if (!data) return [];
    
    const result = [];
    data?.forEach((hourBlock, blockIndex) => {
      hourBlock.days.forEach((day, dayIndex) => {
        result.push({
          key: `${blockIndex}-${dayIndex}`,
          day: getFullDayName(day),
          hours: hourBlock.times[0] || "N/A",
        });
      });
    });
    return result;
  }, [data]);


  return (
    <div className="zl-tabs-content">
      <Flex vertical gap={28}>
        <Flex vertical gap={4}>
          <CustomTitle
          className="zl-custom-title-sm"
            text="Cargo Service - All Shipments"
            fontSize="20px"
            fontWeight="700"
            lineHeight="24px"
            marginBottom='0.2em'
            color="black"
          />
          <CustomTitle
  text={
    <>
      {`${address?.line_1}\n${address?.country}, ${address?.state} ${address?.zipcode}`
        .split('\n')
        .map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}
    </>
  }
  fontSize="12px"
  fontWeight="400"
  lineHeight="20px"
  color="black"
  marginBottom="0"
  marginTop="0"
/>

        </Flex>
        <Flex vertical gap={8}>
          <Flex gap={10} justify="space-between">
            <CustomTitle
              text="Operating hours"
              fontSize="16px"
              fontWeight="600"
              lineHeight="20px"
              color="black"
              marginBottom="0.2em"
              marginTop="0"
            />
            <Tag className="zl-custom-success-tag">Open now</Tag>
          </Flex>

          <Table
             className="zl-custom-times-table"
                      columns={columns}
                      dataSource={dataSource}
                      pagination={false}
                      showHeader={false}
                      bordered={true}
                      size="middle"
                      style={{ borderRadius: "8px" }}
                      /> 
          {/* <List
            className="zl-opening-hours-list"
            bordered
            dataSource={hoursData}
            renderItem={(item) => (
              <List.Item>
                <Flex
                  align="center"
                  justify="space-between"
                  style={{ width: "100%" }}
                >
                  <span className="list-item">{item.day}</span>
                  <time className="list-item">{item.time}</time>
                </Flex>
              </List.Item>
            )}
          /> */}
        </Flex>
        {/* <Flex gap={10} align="center" justify="space-between" wrap>
          <CustomTitle
            text="Minimum times"
            fontSize="16px"
            fontWeight="600"
            lineHeight="20px"
            color="black"
            marginBottom="0"
          />
          <Segmented
            className="zl-custom-segmented"
            value={selectedTab}
            onChange={setSelectedTab}
            options={[
              { label: "Dropoff", value: "dropoff" },
              { label: "Pickup", value: "pickup" },
            ]}
          />
        </Flex>
        <TimesTable selectedTab={selectedTab} /> */}
       
      </Flex>
    </div>
  );
};

export default TabsContent;
